import { render } from "./RequestForDemo.vue?vue&type=template&id=b258e86c"
import script from "./RequestForDemo.vue?vue&type=script&lang=js"
export * from "./RequestForDemo.vue?vue&type=script&lang=js"

import "./RequestForDemo.vue?vue&type=style&index=0&id=b258e86c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__